import {useState, useEffect} from 'react'
import Template from "../components/Template"
import {Button, Form, Container, Alert} from 'react-bootstrap'
import { WithContext as ReactTags } from 'react-tag-input'
import {createDocument} from '../actions/documentActions'
import {getMembersBySearch} from '../actions/memberActions'
import {DOCUMENT_CREATE_CLEAR} from '../constants/documentConstant'
import {useDispatch, useSelector} from 'react-redux'
import Loader from '../components/Loader'

const KeyCodes = {
    enter: 13
}

const delimiters = [KeyCodes.enter]

const AddDocument = () => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [files, setFiles] = useState('')
  const [tags, setTags] = useState([])
  const dispatch = useDispatch()
  const {loading, error, message} = useSelector(state => state.newDocument)
  const {loading:loading_sg, error:error_sg, members} = useSelector(state => state.memberSearch)

  const handleInputChange = value => {
    dispatch(getMembersBySearch(value))
  }

  const handleDelete = i => {
        setTags(tags.filter((tag, index) => index !== i))
    }

  const handleAddition = tag => {
        setTags([...tags, tag])
    }

  const documentHandler = e => {
        e.preventDefault()
        const linkedMembers = tags.map(tag => ({_id:tag._id}))
        const data = new FormData()
        data.append('title', title)
        data.append('description', description)
        data.append('members', JSON.stringify(linkedMembers))
        for(let i = 0; i < files.length; i++){
            data.append('files', files[i])
        }
        dispatch(createDocument(data))
    }

    useEffect(() => {
        if(members) {
            setSuggestions([...members])
        }else if(loading_sg){
            setSuggestions([{id:'جارى البحث ...', name:"جارى البحث ..."}])
        }else if(error_sg){
            setSuggestions([{id:error_sg, name:error_sg}])
        }
        return () => {
            dispatch({type:DOCUMENT_CREATE_CLEAR})
        }
    }, [members, loading_sg, error_sg, dispatch])

    return (
        <Template>
            <h2 className="main__title">إضافة وثيقة جديدة</h2>
            <Container>
                <div className="documents__add">
                    <Form onSubmit={documentHandler}>
                        {loading ? <Loader/>
                        :error ? <Alert variant='danger'>{error}</Alert>
                        :message && <Alert variant='success'>{message}</Alert>}
                        <Form.Group>
                            <Form.Label>عنوان الوثيقة</Form.Label>
                            <Form.Control type="text" placeholder="عنوان الوثيقة" onChange={({target:{value}}) => setTitle(value)} required/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>وصف الوثيقة</Form.Label>
                            <Form.Control as="textarea" rows={5} placeholder="وصف مختصر للوثيقة" onChange={({target:{value}}) => setDescription(value)} required/>
                        </Form.Group>

                        <Form.Group style={{position:'relative'}}>
                            <Form.Label>الأعضاء المرتبطون بالوثيقة</Form.Label>
                            <ReactTags
                                inline
                                placeholder='أضف اسم العضو المرتبط بالوثيقة'
                                tags={tags}
                                suggestions={suggestions}
                                labelField={'name'}
                                handleDelete={handleDelete}
                                handleAddition={handleAddition}
                                handleInputChange={handleInputChange}
                                delimiters={delimiters} />
                        </Form.Group>

                        <Form.Group>
                            <Form.File multiple label="أرفق صورة أو PDF أو فيديو" onChange={(e) => setFiles(e.target.files)}/>
                        </Form.Group>

                        <Button variant="primary" type="submit">
                        حفظ
                        </Button>
                    </Form>
                </div>
            </Container>
        </Template>
    )
}

export default AddDocument
